module.exports = __webpack_public_path__ + "img/sport-football.21e8bf3f.svg";